import MasterStockList from "pages/report/master-stock/list"
import useMasterStockValueDetailReportRepositories from "repositories/master-stock-value-detail-report"

export default function List() {
  return (
    <MasterStockList
      title="Nilai Stock Barang Detail"
      description="Ringkasan nilai stock barang per product unit pada tanggal yang dipilih."
      labelHeader="KODE BARANG"
      endpoint="/reports/master-stock-value-detail"
      useRepository={useMasterStockValueDetailReportRepositories}
    />
  )
}
